interface Props {
	fillcolor: string;
}

export const ArrowRight = ({ fillcolor }: Props) => {
	/*********************
	// #region Redux
	**********************/

	return (
		<svg
			width="10"
			height="17"
			viewBox="0 0 10 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 15.2631L1.57895 16.842L10 8.42099L1.57895 -6.48499e-05L0 1.57888L5.78947 7.36836L6.84211 8.42099L5.78947 9.47362L0 15.2631Z"
				fill={fillcolor}
			/>
		</svg>
	);
};
